import UniqueCustomFieldsProxy from "../unique-custom-fields-proxy";
import ProjectSession from "./project-session";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import PlanningManger from "../../gd/manager/planning-manager";
import Moment from "moment";
import ProjectActions from "./actions/actions";
import {momentRange} from "../../gd/convert/moment-range";
import {DurationDays} from "../types";
import {calculateProjectDisplayEndDate, calculateProjectDisplayStartDate} from "./functions/display-dates";
import {projectApplyDelta} from "./functions/delta";
import {SystemStatus} from "../../gd/const/system-status";
import TimeReportsCollection from "../time-report/collection";
import TasksCollection from "../task/collection";
import EntityCollection from "../entities-collection/entities-collection";
import ExpensesCollection from "../expenses/expense/expenses";
import Expense from "../expenses/expense/expense";
import {ProjectRole} from "../../gd/const/project";
import projectSetCalendarDuration from "./actions/set-calendar-duration";
import WorkScheduleProto from "../../gd/manager/work-schedule/work-schedule-proto";
import projectSetWorkdayDuration from "./actions/set-workday-duration";
import {calculateWorkdayDuration} from "../../gd/manager/start-end-duration/calculate-workday-duration";
import {calculateCalendarDuration} from "../../gd/manager/start-end-duration/calculate-calendar-duration";
import projectUpdateStartDate, {UpdateDateOptions} from "./actions/update-start-date"
import projectUpdateEndDate from "./actions/update-end-date"
import projectUpdateStartEndDate from "./actions/update-start-end"
import projectSetOwner from "./actions/set-owner";
import {SortDirection} from "../../data-structures/sort"
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import {ProjectSystemType} from "./types";
import Project_updateSystemStatus from "./actions/update-system-status";

const debug = false;
// const debug = 'Project';

export default class Project extends ProjectSession {


    public descriptionRTF           : any

    public health                   : number
    public statusComments           : string    // text comments for status

    public priority                 : number     // project priority - tak sebe pole

    public deadline                 : Moment | null
    public _startDate               : Moment | null
    public _endDate                 : Moment | null
    public dateCreated              : Moment | null

    public progress                 : number | null
    public estimate                 : number | null
    // public estimateTasks      : number | null  = null   // totak tasks estimate sum (based on collection in portfolio no exists in this model)

    // getter implemented
    public _ownerUserId             : ID | null   // project Owner

    public users?                   : any[] // tak po hodu ne IDS ... a objects ....
    // public users              : ID[] // array of user ids - a nahrena ... iz sesion nado brat' ? stremnii moment


    private _estimateTasks          : number | null = null // is filled by listItem_UpdateCalculatedValues

    // eto custom fields data SAMOGO project
    public customFieldsData         : CustomFieldsData


    // came from gantt
    public progressSubItems?        : any // it table this is {done:X total:X}   number       // claculated somewhere esle just stored here
    public duration?                : DurationDays // claculated somewhere esle just stored here

    public displayStartDate?        : Moment    // tut ne kak s task - pochemu ... hez voprosi k Gantt skoree vsego tam vlozennost' navernoe
    public displayEndDate?          : Moment

    public _durationWorkdays        : number | undefined | null // undefined means calculation is required
    public _durationCalendar        : number | undefined | null // undefined means calculation is required

    // public predecessors?            : any[]
    // public successors?              : any[]
    public predecessors             : EntityCollection = new EntityCollection([])
    public successors               : EntityCollection = new EntityCollection([])


    public reportedTime?            : number    // used in portfolio at least - total reported time

    public costInternal             : number        = 0
    public costExternal             : number        = 0
    public calculatedCostExternal?  : number        = 0     // is filled by listItem_UpdateCalculatedValues

    public estimatedCostInternal?   : number   = 0
    public estimatedCostExternal?   : number   = 0
    public progressTasks?           : number    // % progress based on number of tasks (open/closed)

    public tasksTotal?              : number    // used in Portfolio Summary View
    public tasksOpen?               : number    // used in portfolio Summary View && projects list

    public timeReports?             : TimeReportsCollection
    public tasks?                   : TasksCollection

    public expenses                 : number // total number of expenses used in portfolio... would bve good to have a collection though...
    public expensesCollection?      : ExpensesCollection


    constructor(data:any, useProxy = true) {

        super(data);

        // this.description        = data['description'] parent
        this.descriptionRTF     = data['descriptionRTF']

        this.health             = data['health']
        this.statusComments     = data['statusComments']    // text comments for status

        this.priority           = data['priority']     // project priority - tak sebe pole

        this.deadline           = data['deadline'] ? DatetimeUtils.dateToMoment(data['deadline']) : null
        this._startDate         = data['startDate'] ? DatetimeUtils.dateToMoment(data['startDate']) : null
        this._endDate           = data['endDate'] ? DatetimeUtils.dateToMoment(data['endDate']) : null

        this.progress           = data['progress']
        this.estimate           = data['estimate']

        this.tasksOpen          = data['tasksOpen']
        this.tasksTotal         = data['tasksTotal']

        // getter implemented
        this._ownerUserId        = data['ownerUserId']   // project Owner

        this.users              = data['users'] // array of user ids - a nahrena ... iz sesion nado brat' ? stremnii moment

        // moved to parent
        // this.localTemplateId    = data['localTemplateId']   // project type
        // this.crmAccountId       = data['crmAccountId']
        // this.isTemplate         = _.get(data,'isTemplate')

        // eto custom fields data SAMOGO project
        this.customFieldsData   = data['customFieldsData'] ? data['customFieldsData'] : {}

        this.expenses           = data['expenses'] || 0



        // NADO razobratsya pochemu 2 field names... ochen' nado !
        // may 2024 - table has 'momentCreated' in data
        this.dateCreated    = data['dateCreated'] ? DatetimeUtils.dateToMoment(data['dateCreated']) : null
        if (!this.dateCreated && data['momentCreated']) {
            this.dateCreated    = DatetimeUtils.dateToMoment(data['momentCreated'])
        }


        // gantt
        this.displayStartDate   = data['displayStartDate'] ? DatetimeUtils.dateToMoment(data['displayStartDate']) : calculateProjectDisplayStartDate(this)
        this.displayEndDate     = data['displayEndDate'] ? DatetimeUtils.dateToMoment(data['displayEndDate']) : calculateProjectDisplayEndDate(this)



        // Time reports
        this.reportedTime       = _.get(data, 'reportedTime', 0)   // when comes from backend as number e.g. portoflio

        if (data.timeReports) {

            this.timeReports = TimeReportsCollection.initFromJson(data.timeReports)

            if (gd.ac.check.company.isManager()) {
                this.costInternal = this.timeReports.costInternal
                this.costExternal = this.timeReports.costExternal
            }
        }

        //
        // IN TASK model this is done with derrived props which is sort of better or not... not better in this case
        // in futer use regular model and cached _xxx value in dynamic properties getter - also need dependencies
        if (data.tasks) {
            this.tasks = TasksCollection.initFromJson(data.tasks)

            if (gd.ac.check.company.isManager()) {
                this.estimatedCostInternal = this.tasks.estimatedCostInternal
                this.estimatedCostExternal = this.tasks.estimatedCostExternal
            }
        }



        return useProxy ? new Proxy(this, UniqueCustomFieldsProxy) : this;
    }

    // is required for sorting to have the same property name as Task
    get title() {
        return this.name
    }

    get iconWithColor(): any {
        return {
            icon    : this.icon,
            color   : this.color
        }
    }

    set iconWithColor(data: {icon?:string, color?:number}) {
        if (data.icon !== undefined)    this.icon = data.icon
        if (data.color !== undefined)   this.color = _.get(data, 'color', 17)
    }

    // now in project- session (parent class)
    // get acl():ProjectAccessControl {
    //     return new ProjectAccessControl(this)
    // }

    quickSearch(quickSearchValueNormalized:string):boolean {
        return this.name.toLowerCase().includes(quickSearchValueNormalized)
    }

    setCustomFieldValue(customFieldId:ID, value:any) {
        // @ts-ignore
        this[customFieldId] = value
    }


    setOwnerUser(id:ID|null) {
        return projectSetOwner(this, id)
    }


    get ownerUserId():ID|null {

        if (this._ownerUserId) {
            return this._ownerUserId
        } else if (this.users) {
            const projectOwner = _.find(this.users, (projectUser:any)=>{
                return projectUser.role === ProjectRole.OWNER
            })
            if (projectOwner) return projectOwner.id
        } else {
            // this is an experimental patch
            // it's used in Gantt when add folder and display project owner set to TRUE
            const projectOwner = gd.session.projectUsers.filterByProject(this.id).findProjectOwner();
            if (projectOwner) {
                // should we set _ownerUserId so not to calculate each time ???
                // like this.setOwnerUserID ?
                return projectOwner.user.id
            }

        }

        return null

        // const projectOwner = gd.session.projectUsers.filterByProject(this.id).findProjectOwner();
        // return projectOwner ? projectOwner.user.id : null;
    }

    set ownerUserId(userId:ID|null) {
        this.setOwnerUser(userId)
    }

    get allUsers(): ID[] {
        let usersIds = _.map(gd.session.projectUsers.notClients(this.id), projectUser=>projectUser.user.id)

        // sorting
        usersIds = _.orderBy(usersIds, [
            id=>{
                let orderRes = 0;
                const user = this.users ? _.find(this.users, u=>u.id === id) : null;
                if (user) {
                    switch (user.role) {
                        case gd.const.project.role.OWNER:           orderRes = 2; break;
                        case gd.const.project.role.PROJECT_MANAGER: orderRes = 1; break;
                    }
                }
                return orderRes;
            },
            id=>gd.session.users.get(id)!.name.toLowerCase()
        ], [SortDirection.DESC,SortDirection.ASC])

        return usersIds
    }

    // DATES

    get startDate() { return this._startDate }
    set startDate(value:Moment|null) {
        this._startDate = value
        this.updatedFields.add('startDate')
        this.onFieldChange('startDate', value)
        this.displayStartDate = calculateProjectDisplayStartDate(this)
    }

    get endDate() {
        return this._endDate
    }
    set endDate(value:Moment|null) {
        this._endDate = value
        this.updatedFields.add('endDate')
        this.onFieldChange('endDate', value)
        this.displayEndDate = calculateProjectDisplayEndDate(this)
    }

    get startEnd() {
        if (this.startDate && this.endDate) return momentRange(this.startDate, this.endDate);
        return null
    }
    set startEnd(dateRange) {

        // v buduchem konechno etot planningManager node kill kogda vse budet cherez model...

        const planningResult = dateRange ?
            PlanningManger.projectStartEnd(this.id, dateRange.start, dateRange.end, {noApiCall: true}) :
            PlanningManger.projectStartEnd(this.id, null, null, {noApiCall: true});

        // strannii tut if etot zachem intresno...
        this.startDate = planningResult.startDate ? planningResult.startDate : null;
        this.endDate = planningResult.endDate ? planningResult.endDate : null;
    }

    get momentCreated() {
        return this.dateCreated
    }

    // DURATION

    get durationWorkdays(): number | null {
        if (this._durationWorkdays===undefined) this._durationWorkdays = calculateWorkdayDuration(this.startDate, this.endDate)
        return this._durationWorkdays
    }
    set durationWorkdays(value:number|null) {
        projectSetWorkdayDuration(this, value)
    }

    get durationCalendar(): number | null {
        if (this._durationCalendar === undefined) this._durationCalendar = calculateCalendarDuration(this.startDate, this.endDate)
        return this._durationCalendar
    }
    set durationCalendar(value:number|null) {
        projectSetCalendarDuration(this, value)
    }

    get workSchedule():WorkScheduleProto {
        return gd.workSchedule.getCompanyWorkSchedule()
    }

    get actions() {
        return new ProjectActions(this);
    }

    set estimateTasks(value: null | number) {
        this._estimateTasks = value
    }

    get estimateTasks():null|number {
        if (!this.tasks || this.tasks.isEmpty) {
            return this._estimateTasks || null
        }

        return this.tasks.estimateTotal || null
    }

    applyDelta(data:any) {
        return projectApplyDelta(this, data)
    }

    updateStartDate(startDate:Moment|null, options:UpdateDateOptions={}) {
        projectUpdateStartDate(this, startDate, options)
        // this = Project WITHOUT proxy so we need manually update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    updateEndDate(endDate:Moment|null) {
        projectUpdateEndDate(this, endDate)
        // this = Project WITHOUT proxy so we need manually update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    updateStartEnd(startDate:Moment|null, endDate:Moment|null) {
        projectUpdateStartEndDate(this, startDate, endDate)

        // this = Project WITHOUT proxy so we need manually update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    // used to update system status
    updateSystemStatus(systemStatus:SystemStatus, renderCallback?:callback) {
        Project_updateSystemStatus(this, systemStatus, renderCallback)
    }

    // used to update status
    updateStatus(newStatusId:ID, cancelCallback?:callback) {
        // cancelCallback used to rerender selector when we cancel update (close non empty project)
        // console.log("updateSystemStatus newValue=", systemStatus, "current value=", this.systemStatus)

        if (this.isFolder || this.isTag) {
            console.error("ERROR #PROJECT-STATUS-2 try update status for folder/tag")
            return
        }

        // dont update to same value
        if (newStatusId === this.statusId) { return }

        // first try updating with force close = False
        const request = gd.api.Project.updateStatus(this.id, newStatusId,false);
        request.done((response:any)=>{

            if (response === 'not-empty') {
                gd.modals.project.confirmCloseNotEmpty(this.id, newStatusId, null, (accepted:any)=>{
                    // set value according to decision made in confirmation dialog

                    if (!accepted) {
                        if (cancelCallback) cancelCallback()
                        return
                    }

                    // second attempt to update status but no reply is expected (close silently is close status is selected)
                    // make change callback when status update done
                    const requestWithForceClose = gd.api.Project.updateStatus(this.id, newStatusId,true);
                    requestWithForceClose.done((response:any)=> {
                        this.statusId = newStatusId
                    })
                });
            } else {
                // changeCallback(newStatusValue);
                // console.log("status updated from first attempt ")
            }

        })
    }

    async save() {
        const params = {}

        debug && console.log(debug,"save()", this.updatedFields);

        if (this.updatedFields.has('name') || this.updatedFields.has('color') || this.updatedFields.has('projectIcon')) {

            gd.api.Project.update(this.id, {
                name: this.name,
                color: this.color,
                projectIcon: this.projectIcon
            });

            // akkuratno vse znacheniya dolzni bit' v modeli tut
            // gd.api.Project.updateProfile(this.id, {
            //     name: this.name,
            //     color: this.color,
            //     projectIcon: this.projectIcon
            // });
            this.updatedFields.delete('name');
            this.updatedFields.delete('color');
            this.updatedFields.delete('projectIcon');
        }

        // Patch - remove fields from table - calculated fields
        if (this.updatedFields.has('duration')) this.updatedFields.delete('duration')
        if (this.updatedFields.has('progressSubItems')) this.updatedFields.delete('progressSubItems')

        // owner
        if (this.updatedFields.has('ownerUserId')) {
            gd.api.Projects.setProjectOwner(this.id, this.ownerUserId);
            this.updatedFields.delete('ownerUserId');
        }

        // deadline
        if (this.updatedFields.has('deadline')) {
            gd.api.Project.setDeadline(this.id, this.deadline);
            this.updatedFields.delete('deadline');
        }

        if (this.updatedFields.has('startEnd') || this.updatedFields.has('startDate') || this.updatedFields.has('endDate')) {
            gd.api.Projects.startEnd(this.id,this.startDate,this.endDate);
            this.updatedFields.delete('startEnd');
            this.updatedFields.delete('startDate');
            this.updatedFields.delete('endDate');
        }

        // health
        if (this.updatedFields.has('health')) {
            gd.api.Project.setHealth(this.id, this.health);
            this.updatedFields.delete('health');
        }

        // priority
        if (this.updatedFields.has('priority')) {
            gd.api.Project.setPriority(this.id, this.priority);
            this.updatedFields.delete('priority');
        }

        // estimate
        if (this.updatedFields.has('estimate')) {
            gd.api.Project.setEstimate(this.id, this.estimate);
            this.updatedFields.delete('estimate');
        }

        // progress
        if (this.updatedFields.has('progress')) {
            // gd.api.Project.setProgress(this.id, this.progress);
            gd.api.Project.update(this.id, {
                progress: this.progress
            })
            this.updatedFields.delete('progress');
        }

        // description
        if (this.updatedFields.has('description') || this.updatedFields.has('descriptionRTF')) {
            gd.api.Project.setDescription(this.id, this.description, this.descriptionRTF);
            this.updatedFields.delete('description');
            this.updatedFields.delete('descriptionRTF');
        }

        // this is for universal update
        this.updatedFields.forEach((fieldName) => {

            // Skip fields
            switch (fieldName) {
                case 'durationCalendar':
                case 'durationWorkdays':
                    // Skip this field - do nothing
                    break

                default:
                    // @ts-ignore
                    params[fieldName] = this[fieldName];
                    break
            }



        })

        // We saved means we need reset !
        this.updatedFields.clear()

        // console.log("Project save", this.id, params);
        if (params && _.size(params)>0) {
            return await gd.api.Project.update(this.id, params).promise;
        }

        return true
    }

    // items collection
    setSortPosition(sortPosition:number) {
        this.sortPosition = sortPosition
    }



    setProjectManagerUser(id:ID) {
        const curManagerUser = _.find(this.users, u=>u.id !== id && u.role === gd.const.project.role.PROJECT_MANAGER);
        //if found manager user other than passed (id) change from manager to simple user
        if (curManagerUser) curManagerUser.role = gd.const.project.role.USER;

        // id can be empty!
        if (id) {
            const user = _.find(this.users, u=>u.id === id);
            if (user) user.role = gd.const.project.role.PROJECT_MANAGER; //if user found in users list then just change it's role
            else {
                if (this.users) {
                    this.users.unshift({ role: gd.const.project.role.PROJECT_MANAGER, id: id }); //if user not found in users list then add new to users list
                }
            }
        }
    }


    // gantt patches

    // moved to parent class
    // get isOpen() {
    //     return gd.const.systemStatus.isOpen(this.systemStatus)
    // }
    //
    // get isClosed() {
    //     return !this.isOpen
    // }



    _calculateDisplayStartDate() {
        return calculateProjectDisplayStartDate(this)
    }

    _calculateDisplayEndDate() {
        return calculateProjectDisplayEndDate(this)
    }

    // END GANTT

    toJSON() {
        let res: JSONObject = {}

        _.mapKeys(this, (value:any, key)=>{
            switch (key) {
                case '_startDate'       :
                    res.startDate = value ? DatetimeUtils.momentToDate(value) : null
                    break

                case '_endDate'         :
                    res.endDate = value ? DatetimeUtils.momentToDate(value) : null
                    break

                case 'deadline'         :
                case 'dateCreated'      :
                case 'displayStartDate' :
                case 'displayEndDate'   :
                    res[key] = value ? DatetimeUtils.momentToDate(value) : null
                    break

                // causes circular toJSON if not empty
                case 'successors'       :
                case 'predecessors'     :
                    res[key] = []
                    break

                default                 :
                    if (key.substring(0,1) === '_') key = key.substring(1)
                    res[key] = value && value.toJSON ? value.toJSON() : value
            }

        })

        return res
    }

    // Dynamic properties
    get parentProjectsIds():ID[] {
        // const result : ID[] = []
        return _.map(this.parentProjects, (parentProject)=>{
            return parentProject.id
        })
    }

    get parentProjects():ProjectSession[] {
        return gd.session.projects.getAllParents(this.id).reverse()
    }

    public addExpense(expense:Expense):void {
        if (!this.expensesCollection) this.expensesCollection = new ExpensesCollection()
        this.expensesCollection.add(expense)
    }


    onFieldChange(field:string, newValue:any) {

        switch (field) {

            case 'startDate':
            case 'endDate':
                this._durationCalendar  = undefined
                this._durationWorkdays   = undefined
                return

            default:
                return
        }
    }


    validate() {


        const errors : any[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.project.name))


        switch (this.systemType) {

            case ProjectSystemType.WORKSPACE:
                if (!this.projectIcon) errors.push(new ErrorFieldRequired(gd.fields.project.projectIcon))
                break

        }

        // if (_.isNil(this.approvalStatus)) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.approvalStatus))
        // if (_.isNil(this.reimbursement)) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.reimbursement))
        //
        // switch (this.systemType) {
        //
        //     case ExpenseSystemType.UNIT:
        //         if (!this.unitName) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.unitName))
        //         if (!this.unitPrice) errors.push(new ErrorFieldRequired(gd.fields.expenseCategory.unitPrice))
        //         break
        //
        //     case ExpenseSystemType.AMOUNT:
        //     default:
        //
        //         break
        // }

        if (_.isEmpty(errors)) return null

        return errors

    }


}
